import React, { useState } from 'react';
import './css/AddRestaurant.css'; // Ensure this path is correct
import axiosRestaurantInstance from './AxiosRestaurantInstance';

const AddRestaurant = () => {
    const user = JSON.parse(localStorage.getItem('user'));

    const [restaurantName, setRestaurantName] = useState('');
    const [cuisineType, setCuisineType] = useState('');
    const [contactNo, setContactNo] = useState('');
    const [email, setEmail] = useState('');
    const [notes, setNotes] = useState('');
    const [status, setStatus] = useState('ACTIVE');
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [country, setCountry] = useState('');
    const [longitude, setLongitude] = useState('');
    const [latitude, setLatitude] = useState('');
    const [addressSuggestions, setAddressSuggestions] = useState([]);

    // Handle Address Search
    const handleAddressSearch = async (e) => {
        setAddressLine1(e.target.value);
        if (e.target.value.length > 2) {
            try {
                const response = await axiosRestaurantInstance.get(`/get-address`, {
                    params: {
                        address: e.target.value,
                    },
                });
                setAddressSuggestions(response.data.suggestions || []);
            } catch (error) {
                console.error('Error fetching address suggestions:', error.response ? error.response.data : error.message);
            }
        } else {
            setAddressSuggestions([]);
        }
    };

    // Handle Address Selection
    const handleAddressSelect = async (placeId) => {
        try {
            // Fetch details for the selected address (using Google API or backend service)
            const response = await axiosRestaurantInstance.get(`/get-address-details`, {
                params: { placeId },
            });

            const placeDetails = response.data;

            if (!placeDetails) {
                alert('Address details not found');
                return;
            }

            // Automatically fill in the form fields with the fetched address details
            setAddressLine1(placeDetails.addressLine1);
            setAddressLine2(placeDetails.addressLine2 || '');
            setPostalCode(placeDetails.postalCode || '');
            setCity(placeDetails.city || '');
            setState(placeDetails.state || '');
            setCountry(placeDetails.country || '');
            setLatitude(placeDetails.latitude || '');
            setLongitude(placeDetails.longitude || '');
            setAddressSuggestions([]); // Clear suggestions after selection
        } catch (error) {
            console.error('Error fetching place details:', error.response ? error.response.data : error.message);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const restaurantData = {
            RestaurantName: restaurantName,
            ContactNo: contactNo,
            Email: email,
            CuisineType: cuisineType,
            Notes: notes,
            Status: status,
            CreatedById: user.userId,
            AddressLine1: addressLine1,
            AddressLine2: addressLine2,
            City: city,
            State: state,
            PostalCode: postalCode,
            Country: country,
            Longitude: longitude,
            Latitude: latitude,
        };

        try {
            const token = localStorage.getItem('Token');
            const response = await axiosRestaurantInstance.post('/restaurant', restaurantData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.status === 201) {
                alert('Restaurant added successfully');
                // Resetting the form fields
                setRestaurantName('');
                setCuisineType('');
                setContactNo('');
                setEmail('');
                setNotes('');
                setStatus('ACTIVE');
                setAddressLine1('');
                setAddressLine2('');
                setCity('');
                setState('');
                setPostalCode('');
                setCountry('');
                setLongitude('');
                setLatitude('');
            } else {
                alert('Failed to add restaurant');
            }
        } catch (error) {
            console.error('Error adding restaurant:', error.response ? error.response.data : error.message);
            alert('An error occurred while adding the restaurant. Check the console for details.');
        }
    };

    return (
        <div className="container">
            <div className="add-restaurant-container visible">
                <form onSubmit={handleSubmit}>
                    <div className="add-restaurant-form-row">
                        <div className="add-restaurant-form-group">
                            <label>Restaurant Name:</label>
                            <input
                                type="text"
                                value={restaurantName}
                                onChange={(e) => setRestaurantName(e.target.value)}
                                placeholder="Enter restaurant name"
                                required
                            />
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>Contact Number:</label>
                            <input
                                type="text"
                                value={contactNo}
                                onChange={(e) => setContactNo(e.target.value)}
                                placeholder="Enter contact number"
                                required
                            />
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>Email:</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter email"
                                required
                            />
                        </div>
                    </div>

                    <div className="add-restaurant-form-row">
                        <div className="add-restaurant-form-group">
                            <label>Cuisine Type:</label>
                            <input
                                type="text"
                                value={cuisineType}
                                onChange={(e) => setCuisineType(e.target.value)}
                                placeholder="Enter cuisine type"
                            />
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>Status:</label>
                            <select value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>Notes:</label>
                            <textarea
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                placeholder="Enter any notes"
                            />
                        </div>
                    </div>

                    {/* Address Section with Autocomplete */}
                    <h3>Address</h3>
                    <div className="add-restaurant-form-row">
                        <div className="add-restaurant-form-group">
                            <label>Address Line 1:</label>
                            <input
                                type="text"
                                value={addressLine1}
                                onChange={handleAddressSearch}
                                placeholder="Enter address line 1"
                            />
                            {/* Dropdown for Address Suggestions */}
                            {addressSuggestions.length > 0 && (
                                <ul className="address-suggestions-dropdown">
                                    {addressSuggestions.map((suggestion) => (
                                        <li
                                            key={suggestion.place_id}
                                            onClick={() => handleAddressSelect(suggestion.place_id)}
                                        >
                                            {suggestion.description}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>Address Line 2:</label>
                            <input
                                type="text"
                                value={addressLine2}
                                onChange={(e) => setAddressLine2(e.target.value)}
                                placeholder="Enter address line 2"
                            />
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>Postal Code:</label>
                            <input
                                type="text"
                                value={postalCode}
                                onChange={(e) => setPostalCode(e.target.value)}
                                placeholder="Enter postal code"
                                required
                            />
                        </div>
                    </div>

                    <div className="add-restaurant-form-row">
                        <div className="add-restaurant-form-group">
                            <label>City:</label>
                            <input
                                type="text"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                placeholder="Enter city"
                                required
                            />
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>State:</label>
                            <input
                                type="text"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                placeholder="Enter state"
                                required
                            />
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>Country:</label>
                            <input
                                type="text"
                                value={country}
                                onChange={(e) => setCountry(e.target.value)}
                                placeholder="Enter country"
                                required
                            />
                        </div>
                    </div>

                    <div className="add-restaurant-form-row">
                        <div className="add-restaurant-form-group">
                            <label>Longitude:</label>
                            <input
                                type="text"
                                value={longitude}
                                onChange={(e) => setLongitude(e.target.value)}
                                placeholder="Enter longitude"
                                readOnly
                            />
                        </div>
                        <div className="add-restaurant-form-group">
                            <label>Latitude:</label>
                            <input
                                type="text"
                                value={latitude}
                                onChange={(e) => setLatitude(e.target.value)}
                                placeholder="Enter latitude"
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="add-restaurant-submit-button">
                        <button type="submit">Add Restaurant</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddRestaurant;
